import React from 'react'
import { Table, Icon } from 'antd';
import { Link } from 'react-router-dom';

class ContributorsTable extends React.Component {
  constructor(props) {
    super(props)
    this.pagination = {}
    //console.log("selectedRow:" + this.props.selectedRow)
    this.rowClassName = this.rowClassName.bind(this)
  }


  rowClassName = (rec, index) => {
    let classname = index === this.props.selectedRow ? 'selectedRow' : ''
    return classname
  }

  render() {

    let pager = this.props.pager
    let contributors = this.props.contributors
    let source = contributors.map(
      x => {
        x.key = x.id
        let address = x.address + ' ' + x.suburb
        return Object.assign({}, x, { address } )
      }
    )

    let columns = [
      {
        title: 'No',
        dataIndex: 'offeringNo',
        key: 'no',
      },
      {
        title: 'Display Name',
        dataIndex: 'displayName',
        key: 'displayName'
      },
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address'
      },
      {
        title: 'Offering',
        dataIndex: 'id',
        key: 'id',
        render:  id => (
          <Link to={`/contributionbymember/${id}`}><Icon type="double-right" /></Link>
        )
      }

    ]

    return <Table columns={columns} dataSource={source} pagination={pager} rowClassName={this.rowClassName}
      onRow={
        (record, rowIndex) => {
          return {
            onClick: (e) => this.props.rowClick(record.key, e) 
          }
        }
      }
    />;
  }

}

export default ContributorsTable
 